<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<span [style.fontSize.px]="size"  >{{value}}</span>
